import { render, staticRenderFns } from "./EditorMenuButton.vue?vue&type=template&id=2b188196&scoped=true"
import script from "./EditorMenuButton.vue?vue&type=script&lang=ts"
export * from "./EditorMenuButton.vue?vue&type=script&lang=ts"
import style0 from "./EditorMenuButton.vue?vue&type=style&index=0&id=2b188196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b188196",
  null
  
)

export default component.exports